import { useModelService } from "@shared/services/api/hooks/useModelService";
import { UseQueryOptions, UseQueryResult } from "react-query";
import { ExtendedAxiosRequestConfig } from "@shared/services/api/abstracts/Repository";
import UserBasedDiscountRepository from "../repositories/UserBasedDiscountRepository";
import { UserBasedDiscountSerializer } from "../types";

const useUserBasedDiscountService = () => {
  const repository = new UserBasedDiscountRepository();

  const modelService = useModelService(repository);

  const useGetUniversalAndOrganizerCredits = ({
    options,
  }: {
    options?: UseQueryOptions<UserBasedDiscountSerializer>;
  } = {}): UseQueryResult<UserBasedDiscountSerializer> => {
    return modelService.useGenericQuery<UserBasedDiscountSerializer>(
      "credits",
      { options }
    );
  };

  const useRedeemGiftCard = () => {
    return modelService.useGenericMutation<void, { redemption_code: string }>(
      "redeemGiftCard",
      "POST"
    );
  };

  function useCancelExchange(config?: ExtendedAxiosRequestConfig) {
    return modelService.useGenericMutation<
      UserBasedDiscountSerializer,
      { user_email: string }
    >("cancelExchange", "POST", {
      config: { showToastOnSuccess: true, ...config },
    });
  }

  return {
    ...modelService,
    repository,
    useRedeemGiftCard,
    useGetUniversalAndOrganizerCredits,
    useCancelExchange,
  };
};

export default useUserBasedDiscountService;
